import React, { useState } from 'react'
import { Card, Collapse } from 'react-bootstrap'
import _ from 'underscore'
import cn from 'classnames'

import INPUT_TYPE_MAP from './input_type_map'
export default class WizardNestedFields extends React.Component {
  constructor(props) {
    super()
    this.state = {
      current_step: '',
      nested: [],
      loading: true,
      toRemoveCount: 0
    }
  }

  UNSAFE_componentWillMount () {
    this.setState({ nested: this._getNestedArray(this.props), current_step: this.props.name })
  }

  UNSAFE_componentWillReceiveProps (newProps) {
    this.setState({ nested: this._getNestedArray(newProps), current_step: newProps.name })
  }

  componentDidMount () {
    this.validateNestedField()
  }

  componentDidUpdate () {
    $(document).trigger('resize')
  }

  render () {
    return (
      <div>
        {this.state.nested.map((id) => {
          return (
            <NestedFields
              key={id}
              id={id}
              {...this.props}
              loading={this.state.loading}
              onSave={this.validateNestedField.bind(this)}
              nestedOne={this.props.nested_one}
              increaseToRemoveCount={this.increaseToRemoveCount.bind(this)}
            />
          )
        })}

        {(!this.props.nested_one || (this.props.nested_one && this.state.nested.length <= this.state.toRemoveCount)) &&
          <div className='mbottom20 dashed-border padding15 clearfix'>
            <button
              type='button'
              className='pull-right btn-default only-icon'
              onClick={this._increaseRepeatCount.bind(this)}
            ><i className='fa mtop5 fa-plus' />
            </button>
            <div className='italic mtop7 text-muted mleft10'>{I18n.t(`wizard_settings.layout.add_${this.props.name}`)}</div>
          </div>}
      </div>

    )
  }

  _increaseRepeatCount () {
    const count = this.state.nested.length + 1
    this.setState({ nested: _.times(count, (i) => i.toString()) })
  }

  _getNestedArray (props) {
    let count = 0
    if (props.nested && props.candidate[props.name]) {
      if (props.name === this.state.current_step) { // the same step
        count = props.candidate[props.name].length > this.state.nested.length ? props.candidate[props.name].length : this.state.nested.length
      } else {
        count = props.candidate[props.name].length || 0
      }
    }
    return _(count).times((i) => i.toString())
  }

  validateNestedField () {
    this.props.validate(
      () => this.setState({ loading: true }), // before
      () => this.setState({ loading: false }), // error
      () => this.setState({ loading: false }) // success
    )
  }

  increaseToRemoveCount () {
    this.setState({ toRemoveCount: this.state.toRemoveCount + 1 })
  }
}

function NestedFields ({ fields, id, candidate, name, onSave, loading, increaseToRemoveCount, nestedOne }) {
  const candidateData = (candidate[name] && candidate[name][id]) || {}
  const [open, setOpen] = useState(_.isEmpty(candidateData))
  const [valid, setValid] = useState(null)
  const [toRemove, setToRemove] = useState(false)
  const toggle = () => {
    setOpen(!open)
  }

  function getErrors () {
    const errors = []
    _.map(fields, (field, fieldName) => errors.push(field.nested_errors && field.nested_errors[id] && fieldName))
    return _.compact(errors)
  }

  React.useEffect(() => {
    const errors = getErrors()
    if (!_.isEmpty(candidateData) || errors.length > 0) {
      setValid(errors.length === 0)
      setOpen(errors.length > 0)
    }
  }, [loading, fields, candidate])

  const stateClass = cn({
    'fa-check green': !loading && valid === true,
    'fa-sync fa-spin': loading,
    'fa-times red': !loading && valid === false
  }, 'fa fa-lg ms-2')

  if (toRemove) return <input type='hidden' name={`candidate[${name}_attributes][${id}][_destroy]`} value='1' />

  return (
    <div className='panel panel-default'>
      <Card>
        <Card.Header className='my-2 flex align-items-center' onClick={toggle}>
          <strong>{I18n.t(`wizard_settings.steps.${name}`)} #{parseInt(id) + 1}</strong>
          <i className={stateClass} />
          <i className={`fa fa-lg ms-auto fa-${open ? 'minus' : 'angle-down'}`} />
        </Card.Header>
        <Collapse in={open} className='px-3 pb-3'>
          <div>
            {candidateData.id &&
              <input type='hidden' name={`candidate[${name}_attributes][${id}][id]`} value={candidateData.id} />}

            {_.map(fields, (field, fieldName) => {
              return (
                <Field
                  id={id}
                  key={fieldName}
                  candidateData={candidateData}
                  field={field}
                  name={name}
                  fieldName={fieldName}
                  nestedOne={nestedOne}
                />
              )
            })}
            <button
              type='button'
              onClick={() => {
                setToRemove(true)
                increaseToRemoveCount()
              }}
              className='btn-secondary pull-right ms-2'
            >{I18n.t('wizard_settings.layout.remove_entry')}
            </button>

            <button
              type='button'
              onClick={onSave}
              className='btn-default pull-right'
            >{I18n.t('wizard_settings.layout.save_entry')}
            </button>

          </div>
        </Collapse>
      </Card>
    </div>
  )
}

function Field (props) {
  const { id, candidateData, field, name, fieldName } = props
  const nestedField = _.extend({}, field)
  nestedField.value = candidateData[fieldName] || ''
  nestedField.name = `candidate[${name}_attributes][${id}][${fieldName}]`
  nestedField.label = ''
  nestedField.field = fieldName
  nestedField.select_options_path = '/applications/fetch_options/'

  if (nestedField.type) {
    const FieldComponent = require(`components/form/${nestedField.type}.js`).default
    return (
      <div
        className={`form-group ${INPUT_TYPE_MAP[nestedField.type]}
                                ${nestedField.nested_errors && nestedField.nested_errors[id] ? 'has-error' : ''}`} key={fieldName}
      >
        <label className={`control-label ${INPUT_TYPE_MAP[nestedField.type]}`}>
          {I18n.t(`wizard_settings.${name}.${fieldName}`)}
          {(nestedField.required || nestedField.immutable) &&
            <abbr title='required' className='mleft5'>*</abbr>}
        </label>
        <FieldComponent {...nestedField} />
        <span className='help-block'>{nestedField.nested_errors && nestedField.nested_errors[id]}</span>
      </div>
    )
  } else {
    return null
  }
}

WizardNestedFields.propTypes = {
  // name: PropTypes.string.isRequired,
  // fields: PropTypes.object,
  // value: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}
